import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "inner-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "hole" })
], -1 /* HOISTED */)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'WireJack',
  props: {
  color: {
    type: String,
    required: true,
  },
  isSelected: {
    type: Boolean,
    required: true,
  },
  orientation: {
    type: String,
    default: () => "up",
  },
},
  emits: ["select"],
  setup(__props, { emit }) {

const props = __props;




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slot", { active: props.isSelected }])
  }, [
    (__props.orientation === 'down')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["led-indicator", [props.color]])
        }, null, 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "slot-input",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('select', $event)))
    }, _hoisted_2),
    (__props.orientation === 'up')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["led-indicator", [props.color]])
        }, null, 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})